<template lang="pug">
  #plans-setting.container-fluid
    h1 Plans
    
    //- .plans-wrap
    .current-plan.card.shadow.mb-4
      .card-header
        p Current Plan: 
          strong {{currentPlanInfo.name}}
        p Returns Remaining This Month: 
          strong {{currentPlanInfo.returnAvaliables}}
  
      form.all-plans.card-body(@submit="updatePlan")
        
        .planinfo(v-for="plan in allPlans") 
          label
            input(type="radio" name="plans" :value="plan.id" v-model="selectedPlan" :id="`plan-${plan.id}`" required) 
            span.pointer {{` ${plan.name} $`}}
              strong {{plan.monthlyPay}}
              span {{` - `}}
              strong {{plan.returnAvaliables}} 
            span returns per month
        //- p Note: If you would like to downgrade back to the free plan, please contact us.
        button.btn.btn-primary(type="submit" @click="updatePlan") Choose Plan

</template>

<script>
import { mapActions, mapState } from 'vuex';
// import router from '../router';
import axios from 'axios';
import { allPlans } from '../constant.js';

export default {
  name: 'Plans',
  components: { },
  data:function(){
    return{
      currentPlanInfo: {},
      allPlans: [...allPlans],
      selectedPlan: null,
    }
  },
  computed: { 
    ...mapState(['currentPlan', 'last4', 'shopifyBilling']),
  },
  methods: {
    setCurrentPlan() {
      this.currentPlanInfo = this.allPlans.find((plan) => plan.id === this.currentPlan);
    },
    async updatePlan(e) {
      try {
        e.preventDefault();
        if (!document.querySelector('form.all-plans').reportValidity()) { return; }
        if (!this.shopifyBilling && !this.last4) {
          this.$router.push({ name: 'Billing' });
          return;
        }
        
        const newPlan = this.allPlans.find((item) => item.id === this.selectedPlan);
        let formData = new FormData();
        formData.append('planId', newPlan.id);
        const response =  await axios.post('/rp/server/plan', formData);

        const { data: { plan : { confirmationUrl, currentPlan: newPlanId } = {} }, error } = response;
        if (error) {
          this.flash(`Ops, Something went wrong, ${error}`, 'error');
          return;
        }
        // this.currentPlanInfo = this.allPlans.find((plan) => plan.id === newPlanId);
        
        if (confirmationUrl) {
          window.location.href = confirmationUrl;
          this.flash('Redirecting to Shopify ...', 'info');
        } else {
          this.flash('Successfully started a new plan', 'success');
        }
      } catch (error) {
        this.flash(`Ops, Something went wrong, ${error}`, 'error');
      }
      
    },
  },
  watch: {
    
  },
  mounted(){
    this.setCurrentPlan();
  },
  metaInfo: {
    title: 'Plans',
  }
 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#plans-setting {

  .current-plan {
  }
  .all-plans {

    .planinfo {
    }
  }
// }
  
}
  
</style>
